import { render, staticRenderFns } from "./PerformanceHome.vue?vue&type=template&id=67b20f7b&scoped=true"
import script from "./PerformanceHome.vue?vue&type=script&lang=js"
export * from "./PerformanceHome.vue?vue&type=script&lang=js"
import style0 from "./PerformanceHome.vue?vue&type=style&index=0&id=67b20f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b20f7b",
  null
  
)

export default component.exports